import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {LoginRouteService} from '../login-route.service';
import {debounceTime, filter, map} from 'rxjs/operators';
import {WindowRef} from '@lifeislife/lifeislife-domain';

@Component({
  selector: 'cf-mail-link-bloc',
  templateUrl: './mail-link-bloc.component.html',
  styleUrls: ['./mail-link-bloc.component.scss'],
  animations: [
    trigger('collapsed', [
      state('false', style({height: 'auto'})),
      state('true', style({height: '0'})),
      transition('false => true', [
        animate('100ms ease-out'),
      ]),
      transition('true => false', [
        animate('100ms ease-out'),
        style({height: '100%'}),
      ]),
    ]),
  ],
})
export class MailLinkBlocComponent implements OnInit, OnDestroy {

  collapsed$: Observable<boolean>;

  waitingForMail = true;
  contactMail: string;
  validating$: Observable<boolean>;

  completed = false;
  mailSent = false;
  errorMessage: string;

  @ViewChild('contactMailForm')
  private theFormElementRef: ElementRef;

  private subscription: Subscription;

  constructor(
    private loginRouteService: LoginRouteService,
    private windowRef: WindowRef,
  ) {

  }

  ngOnInit(): void {
    this.subscription = new Subscription();

    const lastEmailSubscription = this.loginRouteService.lastUsedMail$
      .subscribe(lastEmail => this.contactMail = lastEmail);
    this.subscription.add(lastEmailSubscription);

    this.collapsed$ = this.loginRouteService.isCollapsed$('mail');
    const expandedSubscription = this.collapsed$.pipe(
      filter(c => c === false),
      debounceTime(200),
    ).subscribe(c => this.focusMailInput());
    this.subscription.add(expandedSubscription);

    this.validating$ = this.loginRouteService.mailLoginInProgress$;

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onSubmit(valid: any) {
    this.errorMessage = null;
    this.completed = false;
    this.mailSent = false;

    this.loginRouteService.authenticateMail$(this.contactMail)
      .subscribe(() => {
          this.completed = true;
          this.mailSent = true;
          this.waitingForMail = false;
        }, e => {
          this.mailSent = false;
          this.completed = true;
          this.errorMessage = this.loginRouteService.mailLoginError;

        },
        () => {
          // this.mailSent = false;
          this.completed = true;
          this.errorMessage = this.loginRouteService.mailLoginError;
        });
  }

  onCloseClick() {
    const window = this.windowRef.getWindow();
    if (window) {
      window.close();
    }
  }

  toggleCollapse() {
    this.loginRouteService.toggleExpanded('mail');
  }

  private focusMailInput() {
    if (this.theFormElementRef) {
      const htmlElement: HTMLFormElement = this.theFormElementRef.nativeElement;
      if (htmlElement) {
        const element: HTMLInputElement = htmlElement.querySelector('input[name=contactMail]');
        if (element && element.focus) {
          element.focus();
        }
      }
    }
  }
}
